import debouncer from './utility/debouncer';

class PublicationIds {
	constructor(filtersDownload) {
		this.filtersDownload = filtersDownload;
		this.publicationIdListener();
	}

	publicationIdListener() {
		const publicationIdTextarea = document.querySelectorAll('.js-publication-id');

		if (publicationIdTextarea) {
			const delay = debouncer(300);
			for (const item of Array.from(publicationIdTextarea)) {
				item.addEventListener('input', () => {
					delay(this.filtersDownload.callWithTimeout());
				});
			}
		}
	}
}

export default PublicationIds;
